import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

const ExprimeCharte = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow relative overflow-hidden">
        {/* Background with gradient and gavroche */}
        <div className="absolute inset-0 z-0">
          <div className="h-full w-full bg-gradient-to-br from-[#FFFF4D] via-[#FFE94B] to-[#A3D960]"></div>
          <div className="absolute top-0 right-0 h-full w-1/3 md:w-2/5 opacity-30 md:opacity-40 flex items-end">
            <img 
              src="/lovable-uploads/180f51c0-05cf-4dfd-b4b7-91b153baf486.png" 
              alt="Décoration" 
              className="h-auto w-full object-contain object-bottom drop-shadow-xl" 
            />
          </div>
        </div>
        
        <div className="container relative z-10 mx-auto px-4 py-16 pt-32">
          <Card className="max-w-3xl mx-auto bg-white/90 backdrop-blur-sm">
            <CardContent className="pt-8 pb-12 px-6">
              <h1 className="text-4xl font-bold text-center mb-12 text-[#001233]">
                Concours exprime la charte
              </h1>
              
              <div className="flex flex-col gap-6 max-w-md mx-auto">
                <Button 
                  size="lg" 
                  className="w-full text-lg h-14 bg-[#4AA9E6] hover:bg-[#3A99D6] text-white"
                  onClick={() => navigate('/exprime-la-charte/inscription')}
                >
                  Inscription au concours
                </Button>
                
                <Button 
                  size="lg" 
                  className="w-full text-lg h-14 bg-[#4AA9E6] hover:bg-[#3A99D6] text-white"
                  onClick={() => navigate('/exprime-la-charte/depot')}
                >
                  Dépôt du projet
                </Button>
                
                <Button 
                  size="lg" 
                  className="w-full text-lg h-14 bg-[#4AA9E6] hover:bg-[#3A99D6] text-white"
                  onClick={() => navigate('/exprime-la-charte/attestation')}
                >
                  Attestation de droit à l'image
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ExprimeCharte;
